import { Component, EventEmitter, Input, Output, ViewContainerRef } from '@angular/core';
import { JobOrderVendorService } from '../../../../../../models/job-orders.interface';
import { InventoryType } from '../../../../../../constants/app-constants';
import { FormGroup } from '@angular/forms';
import { DynamicForm } from '../../../../../../models/dynamic-form';
import { TableMeta } from '../../../../../../models/table-meta.interface';
import { DynamicFormService } from '../../../../../../services/dynamic-form.service';
import { VendorServiceFormComponent } from '../../../vendor-service-form/vendor-service-form.component';
import { ModalComponent } from '../../../../../modal/modal.component';

import ManageServiceConfig from './manage-service-config.json';
import { StaticTableComponent } from '../../../../../static-table/static-table.component';
import { SvgIconComponent } from '../../../../../svg-icon/svg-icon.component';
import { SERVICE_ACTION } from '../../../../../../services/job.order.service';
import { SharedModule } from '../../../../../../modules/shared/shared.module';
import { ToasterService } from '../../../../../../services/toaster.service';

@Component({
  selector: 'app-manage-inventory-service',
  standalone: true,
  imports: [StaticTableComponent, SvgIconComponent, SharedModule],
  templateUrl: './manage-inventory-service.component.html',
  styleUrl: './manage-inventory-service.component.scss'
})
export class ManageInventoryServiceComponent {

  @Input() serviceList!: JobOrderVendorService[];
  @Input() inventoryType!: InventoryType;
  @Input() itemDetails!: any;
  @Input() formGroup!: FormGroup;
  @Input() dynamicForm!: DynamicForm;
  @Input() readonly: boolean = false;
  @Input() parentViewContainerRef!: ViewContainerRef;

  @Output() serviceListListener = new EventEmitter<JobOrderVendorService[]>();

  InventoryType = InventoryType;
  serviceTableMeta!: TableMeta;

  constructor(private viewContainerRef: ViewContainerRef, 
    private dynamicFormService: DynamicFormService,
    private toasterService: ToasterService
  ) {
    this.serviceTableMeta = ManageServiceConfig.serviceTableMeta;
  }

  ngOnInit() {
    this.serviceList?.forEach(js => this.updateAttributeListView(js)); 
    console.log("dynamic form: ", this.dynamicForm);
    if (this.dynamicForm && this.formGroup) {
      this.dynamicFormService.addControlsToForm(this.formGroup, this.dynamicForm, false);
      this.formGroup.patchValue({
        ...this.itemDetails
      });
    }
  }

  handleRowAction(event: { actionName: string, index: number }) {
    if (event.actionName === 'edit-service') {
      this.configureService(SERVICE_ACTION.EDIT, this.serviceList[event.index]);
    } else if (event.actionName === 'delete-service') {
      this.serviceList.splice(event.index, 1);
    }
  }

  configureServices() {
    this.configureService(SERVICE_ACTION.ADD);
  }

  configureService(action: SERVICE_ACTION, record?: JobOrderVendorService) {
    const modalComponentRef = this.parentViewContainerRef.createComponent(ModalComponent);
    modalComponentRef.instance.title = "Edit Service";
    modalComponentRef.instance.width = "55vw";

    const manageAttributeRef = modalComponentRef.instance.loadComponent(VendorServiceFormComponent);
    manageAttributeRef.setInput("jobOrderVendorService", record);
    manageAttributeRef.setInput("inventoryType", this.inventoryType);
    manageAttributeRef.setInput("loadedOnModal", true);
    manageAttributeRef.setInput("allowInventorySelection", false);
    

    modalComponentRef.instance.close.subscribe((event: {jobOrderVendorService: JobOrderVendorService, appliedInventoryIds: string[]}) => {
      if (event?.jobOrderVendorService) {
        const jobOrderService = event.jobOrderVendorService;
        this.updateAttributeListView(jobOrderService);
        if (action === SERVICE_ACTION.ADD) {
          const existingService = this.serviceList.find(v => v.serviceId === jobOrderService.serviceId);
          if (existingService) {
            this.toasterService.error(`Service already added`);
            return;
          }
          this.serviceList.push(jobOrderService);
        }
      }
      modalComponentRef.destroy()
    });
  }

  publishUpdatedList(): void {
    this.serviceListListener.emit(this.serviceList);
  }
  
  private updateAttributeListView(joborderService: JobOrderVendorService) {
    if (joborderService.attributes?.length) {
      for (let j = 0; j < joborderService.attributes?.length; j++) {
        const attribute = joborderService.attributes[j];
        attribute.displayValue = `${attribute.name} : ${attribute.values[0].value}`;
      }
    }
  }

  onServiceListChange(updatedList: JobOrderVendorService[]) {
    this.serviceList = updatedList;
    this.serviceListListener.emit(updatedList);
  }
}
